// extracted by mini-css-extract-plugin
export default {"classroomCard":"classroomCard__r7o8R","active":"active__kM5NO","disabled":"disabled__nTLKP"};